import { type PaymentOption } from "@/types";

/** UAE BNPL+ (consumer finance): matches order-details `isUaeBnplPlus` detection. */
export function isUaeBnplPlusProduct(
  countryCode: string | null | undefined,
  productType: string | null | undefined,
): boolean {
  const cc = (countryCode ?? "").toUpperCase();
  return (
    (cc === "AE" || cc === "ARE") && productType === "PURCHASE_FINANCING"
  );
}

/** Term-cost row label: UAE BNPL+ (legal) uses "Service Fee"; other markets (e.g. KSA) use "Murabaha profit". */
export function termCostLineItemLabelKey(
  isUaeBnplPlus: boolean,
): "total.service_fee" | "total.murabaha_profit" {
  return isUaeBnplPlus ? "total.service_fee" : "total.murabaha_profit";
}

/** Non–KFS documents sheet title: UAE BNPL+ uses "Financing documents"; other markets use "Murabaha documents". */
export function financingDocumentsTitleKey(
  isUaeBnplPlus: boolean,
): "documents.financing_documents" | "documents.murabaha_documents" {
  return isUaeBnplPlus
    ? "documents.financing_documents"
    : "documents.murabaha_documents";
}

/** Footer / sheet agreement line: UAE BNPL+ uses financing copy; KSA and others keep Murabaha. */
export function agreeFinancingAgreementsLabelKey(
  isUaeBnplPlus: boolean,
):
  | "payment_confirmation.agree_financing_agreements"
  | "payment_confirmation.agree_murabaha_agreements" {
  return isUaeBnplPlus
    ? "payment_confirmation.agree_financing_agreements"
    : "payment_confirmation.agree_murabaha_agreements";
}

export const emptyPaymentOption: PaymentOption = {
  offerId: "",
  tenure: 0,
  downPaymentAmount: {
    amount: 0,
    currency: "",
  },
  processingFeeAmount: {
    amount: 0,
    currency: "",
  },
  instalmentAmount: {
    amount: 0,
    currency: "",
  },
  principalAmount: {
    amount: 0,
    currency: "",
  },
  termCostAmount: {
    amount: 0,
    currency: "",
  },
  totalToBeRepaidAmount: {
    amount: 0,
    currency: "",
  },
  totalCustomerFeeAmount: {
    amount: 0,
    currency: "",
  },
  averageMonthlyFee: undefined,
  schedulePreview: [],
  subvention: null,
  waivedOffFee: null,
  waivedOffReason: null,
  isFeeWaivedOff: false,
  needsDocumentSigning: false,
  equalDownPaymentStrategy: true,
  preSelected: false,
};
